import styled from "styled-components";
import {themes} from "../../config/themes";

export const Content = styled.div`
  background: #252D3A;
  width: 100%;
  height: 100vh;
`;